// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_ac1a46', '__Inter_Fallback_ac1a46'","fontStyle":"normal"},"className":"__className_ac1a46"};